<template>
	<div id="expenseEditModal" style="display: block" class="modal" role="dialog">
		<div class="modal-backdrop" @click="$emit('close')"></div>
		<div class="modal-dialog">
			<loading
				:active.sync="isLoading"
				class="loading"
				:is-full-page="false"
			></loading>
			<div class="modal-content">
				<div class="modal-header text-center">
					<div class="cancelSection">
						<b-button class="btnSize" @click="goBack">Cancel</b-button>
					</div>
					<div>
						<h3 class="titleText" v-if="!expenseDetail.Reviewed">
							Review Receipt
						</h3>
						<h3 class="titleText" v-else>Update Receipt</h3>
					</div>
					<div class="updateSection">
						<b-button
							class="btnSize"
							variant="success"
							@click="updateReceipt(expenseDetail.ReceiptId)"
							>Update</b-button
						>
					</div>
				</div>
				<div class="modal-body">
					<div class="imgSection">
						<b-img
							v-if="previewImage"
							:src="previewImage"
							rounded
							fluid
							alt="Center image"
						></b-img>
					</div>
					<input
						type="text"
						v-model="expenseDetail.ReceiptId"
						class="form-control block"
						hidden
					/>
					<div class="block amountWrapper" type="button">
						<div class="currencyAmountWrapper" @click="wantsToUpdateExpense">
							<input
								v-if="isExpenseEditing"
								type="number"
								class="form-control block cellAmount"
								:value="expenseRenderAmount"
								@blur="expenseInputBlur($event)"
							/>
							<span v-else class="expenseAmount">{{
								`${
									newExpenseAmount
										? newExpenseAmount
										: toFormatedCurrency(
												expenseRenderAmount,
												currencyCode === "USD" ? currencySymbol : currencyCode
										  )
								}`
							}}</span>
						</div>

						<button class="currencyButton" @click="showCurrency()">
							<span>{{ currencyCode }}</span>
							<font-awesome-icon :icon="['fas', 'chevron-right']" />
						</button>
					</div>

					<div v-if="currencyCode !== 'USD'" class="block" type="button">
						<span class="textCell">USD</span>
						<input
							class="equivalentUSDInput"
							v-if="isEquivalentUSDEditing"
							type="number"
							:value="equivalentUSD || expenseDetail.Amount"
							@blur="equivalentUSDInputBlur($event)"
						/>
						<span
							v-else
							class="selectedItem bold"
							@click="wantsToUpdateEquivalentUSD"
						>
							{{
								toFormatedCurrency(equivalentUSD || expenseDetail.Amount, "$")
							}}
						</span>
					</div>

					<div class="block" type="button" @click="showVendor()">
						<span class="textCell">Vendor</span>
						<span class="selectedItem">{{ selectedVendorName }}</span>
						<font-awesome-icon
							:icon="['fas', 'chevron-right']"
							class="cellIcon"
						/>
					</div>

					<div class="block" type="button" @click="showCategory()">
						<span class="textCell">Category</span>
						<span class="selectedItem">{{ selectedCategoryName }}</span>
						<font-awesome-icon
							:icon="['fas', 'chevron-right']"
							class="cellIcon"
						/>
					</div>

					<div class="block" type="button" @click="changeReimbursable()">
						<span class="textCell">Reimbursable</span>
						<b-form-checkbox
							v-model="expenseDetail.Reimbursable"
							value="1"
							unchecked-value="0"
							@change="changeReimbursable()"
						></b-form-checkbox>
					</div>

					<div class="block" type="button" @click="dateOn = !dateOn">
						<span class="textCell">Transaction Date</span>
						<span class="selectedItem">{{
							expenseDetail.TransactionDate | moment("MMMM D, YYYY")
						}}</span>
					</div>
					<div class="datepicker" v-if="dateOn">
						<datepicker
							:value="selectedDate"
							:inline="true"
							@selected="changeDate"
						></datepicker>
					</div>

					<div class="block" type="button" @click="showProject()">
						<span class="textCell">Project</span>
						<span class="selectedItem">{{ selectedProjectName }}</span>
						<font-awesome-icon
							:icon="['fas', 'chevron-right']"
							class="cellIcon"
						/>
					</div>
					<div class="block" type="button" @click="showPaymentMethod()">
						<span class="textCell">Payment Method</span>
						<span class="selectedItem">{{ selectedPaymentMethodName }}</span>
						<font-awesome-icon
							:icon="['fas', 'chevron-right']"
							class="cellIcon"
						/>
					</div>
					<div class="block" type="button" @click="showPayer()">
						<span class="textCell">Payer</span>
						<span class="selectedItem">{{ selectedPayerName }}</span>
						<font-awesome-icon
							:icon="['fas', 'chevron-right']"
							class="cellIcon"
						/>
					</div>
					<div class="note-text-area">
						<p class="note-title">Note</p>
						<b-form-textarea
							v-model="expenseDetail.Note"
							class="form-control block textArea"
							rows="3"
							placeholder="Notes"
						></b-form-textarea>
					</div>
					<div v-if="!expenseDetail.Reviewed">
						<b-button
							block
							class="btnSize"
							variant="danger"
							@click="
								showDeleteConfirm('receipt', () =>
									deleteReceipt(expenseDetail.ReceiptId)
								)
							"
							>Delete Receipt</b-button
						>
					</div>
				</div>
			</div>
		</div>
		<CurrencyModal
			v-if="currencyShow"
			@close="currencyShow = false"
			:currencyCode="currencyCode"
			:currencySymbol="currencySymbol"
			@currencyIsChanged="currencyIsChanged"
		/>
		<Attribute
			v-if="vendorShow"
			id="attributeModal"
			@close="vendorShow = false"
			:selectedAttributeName="selectedVendorName"
			@selectDone="selectedVendorItem"
			:type="'Vendor'"
		></Attribute>
		<Attribute
			v-if="categoryShow"
			id="attributeModal"
			@close="categoryShow = false"
			:selectedAttributeName="selectedCategoryName"
			@selectDone="selectedCategoryItem"
			:type="'Category'"
		></Attribute>
		<Attribute
			v-if="projectShow"
			id="projectModal"
			@close="projectShow = false"
			:selectedAttributeName="selectedProjectName"
			@selectDone="selectedProjectItem"
			:type="'Project'"
		></Attribute>
		<Attribute
			v-if="showPaymentMethodModal"
			id="attributeModal"
			@close="showPaymentMethodModal = false"
			:selectedAttributeName="selectedPaymentMethodName"
			@selectDone="selectedPaymentMethodItem"
			:type="'Payment Method'"
		></Attribute>
		<Attribute
			v-if="showPayerModal"
			id="attributeModal"
			@close="showPayerModal = false"
			:selectedAttributeName="selectedPayerName"
			@selectDone="selectedPayerItem"
			:type="'Payer'"
		></Attribute>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { mapState } from "vuex";
import { getUserId } from "../utils/auth";
import CurrencyModal from "./expense/Currency.vue";
import Attribute from "./Attribute";
import Category from "./Category";
import Project from "./Project";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
	name: "Edit",
	props: ["receiptToPass"],
	data() {
		return {
			isLoading: false,
			expenseId: this.receiptToPass,
			expenseDetail: { Reviewed: true },
			selectedVendorName: "",
			selectedCategoryName: "",
			selectedProjectName: "",
			selectedPaymentMethodName: "",
			selectedPayerName: "",
			previewImage: null,
			userId: getUserId(),
			currencyShow: false,
			vendorShow: false,
			categoryShow: false,
			projectShow: false,
			showPaymentMethodModal: false,
			showPayerModal: false,
			dateOn: false,
			newExpenseAmount: null,
			currencyCode: null,
			currencySymbol: null,
			expenseOriginalAmount: null,
			expenseRenderAmount: null,
			isExpenseEditing: false,
			equivalentUSD: null,
			isEquivalentUSDEditing: false
		};
	},
	components: {
		CurrencyModal,
		Attribute,
		Category,
		Project,
		Loading,
		Datepicker
	},
	async mounted() {
		try {
			this.isLoading = true;
			await this.$store.dispatch("loadAttribute");
			await this.getReceipt();
		} catch (error) {
			return error;
		} finally {
			this.isLoading = false;
		}
	},
	computed: {
		...mapState(["activeExpense"]),
		selectedDate: function() {
			return moment(this.expenseDetail.TransactionDate).toDate();
		}
	},
	methods: {
		async getReceipt() {
			try {
				const { data } = await this.$axios.get(
					`/receipt?id=${this.expenseId}`,
					{ crossdomain: true }
				);
				data.Receipt["Amount"] = (
					Math.round(data.Receipt["Amount"] * 100) / 100
				).toFixed(2);
				this.expenseDetail = data.Receipt;
				this.selectedVendorName = this.expenseDetail.VendorName;
				this.selectedCategoryName = this.expenseDetail.CategoryName;
				this.selectedProjectName = this.expenseDetail.ProjectName;
				this.selectedPaymentMethodName = this.expenseDetail.PaymentType;
				this.selectedPayerName = this.expenseDetail.Payer;
				this.currencyCode = this.expenseDetail.CurrencyCode;
				this.expenseOriginalAmount =
					this.expenseDetail.CurrencyCode === "USD"
						? parseFloat(this.expenseDetail.Amount)
						: this.expenseDetail.CurrencyAmount;
				this.expenseRenderAmount =
					this.expenseDetail.CurrencyCode === "USD"
						? parseFloat(this.expenseDetail.Amount)
						: this.expenseDetail.CurrencyAmount;
				this.equivalentUSD = this.expenseDetail.Amount;
				this.currencySymbol = this.expenseDetail.CurrencySymbol;
				this.previewImage =
					"https://" +
					this.expenseDetail.FileBucket +
					".s3.amazonaws.com/" +
					this.expenseDetail.UserId +
					"/" +
					this.expenseDetail.FileName;
			} catch (error) {
				return error;
			}
		},
		changeReimbursable() {
			this.expenseDetail.Reimbursable =
				this.expenseDetail.Reimbursable === 1 ? 0 : 1;
		},
		changeDate(date) {
			const newDate = moment(date).format("YYYYMMDD");
			this.expenseDetail.TransactionDate = newDate;
			this.dateOn = false;
		},
		updateReceipt(id) {
			this.isLoading = true;
			let submitData = {
				id: id,
				vendor: this.selectedVendorName,
				category: this.selectedCategoryName,
				amount: parseFloat(this.equivalentUSD),
				project: this.selectedProjectName,
				transaction_date: this.expenseDetail.TransactionDate,
				reimbursable: this.expenseDetail.Reimbursable,
				note: this.expenseDetail.Note,
				reviewd: 1,
				payment_type: this.selectedPaymentMethodName,
				payer: this.selectedPayerName,
				currency_code: this.currencyCode,
				currency_symbol: this.currencySymbol,
				currency_amount: parseFloat(this.expenseRenderAmount)
			};
			this.$axios
				.post("receipt", submitData, { crossdomain: true })
				.then(
					response => {
						if (response.status === 200) {
							// store the response on vuex
							var expense = response.data.Receipt;
							expense.loaded = true;
							expense.icon = this.getCategoryIcon(expense.CategoryName);
							this.$store.dispatch("updateExpense", { expense: expense });

							// pass the expense back to the source
							if (this.$parent.updatedExpense) {
								this.$parent.updatedExpense(expense);
							}
						}
					},
					err => {
						return err;
					}
				)
				.finally(() => {
					this.isLoading = false;
				});
		},
		goBack() {
			this.$emit("close");
		},
		showCurrency() {
			this.currencyShow = true;
		},
		showVendor() {
			this.vendorShow = true;
		},
		showCategory() {
			this.categoryShow = true;
		},
		showProject() {
			this.projectShow = true;
		},
		showPaymentMethod() {
			this.showPaymentMethodModal = true;
		},
		showPayer() {
			this.showPayerModal = true;
		},
		selectedVendorItem(vendor) {
			this.selectedVendorName = vendor.Name;
			this.vendorShow = false;
		},
		selectedCategoryItem(catSelected) {
			this.selectedCategoryName = catSelected.Name;
			this.categoryShow = false;
		},
		selectedProjectItem(proSelected) {
			this.selectedProjectName = proSelected.Name;
			this.projectShow = false;
		},
		selectedPaymentMethodItem(selectedPaymentMethod) {
			this.selectedPaymentMethodName = selectedPaymentMethod.Name;
			this.showPaymentMethodModal = false;
		},
		selectedPayerItem(selectedPayer) {
			this.selectedPayerName = selectedPayer.Name;
			this.showPayerModal = false;
		},
		async deleteReceipt(id) {
			try {
				this.isLoading = true;
				let params = { data: { id } };
				await this.$axios.delete("receipt", params, { crossdomain: true });
				this.goBack();
				this.$store.dispatch("removeExpense", { id: id });
			} catch (error) {
				return error;
			} finally {
				this.isLoading = false;
			}
		},
		expenseAmountChanged($event) {
			this.newExpenseAmount = $event.target.value;
		},
		async currencyIsChanged(currencyCode, symbol) {
			try {
				this.currencyCode = currencyCode;
				this.currencySymbol = symbol;
				await this.getExchangeRate();
			} catch (error) {
				return error;
			} finally {
				this.currencyShow = false;
			}
		},
		async expenseInputBlur(event) {
			try {
				this.isExpenseEditing = false;
				this.expenseRenderAmount = event.target.value;
				await this.getExchangeRate();
			} catch (error) {
				return error;
			} finally {
			}
		},
		equivalentUSDInputBlur(event) {
			const amount = event.target.value;
			this.equivalentUSD = amount;
			this.isEquivalentUSDEditing = false;
		},
		wantsToUpdateExpense() {
			this.isExpenseEditing = true;
			setTimeout(() => {
				document.querySelector(".cellAmount").focus();
			}, 500);
		},
		async getExchangeRate() {
			const exchangeResponse = await this.$axios.get(
				`https://openexchangerates.org/api/latest.json?app_id=e2bd25860d114bbb954e6577cb10d555&base=${this.currencyCode}&symbols=USD`
			);
			const rates = exchangeResponse.data.rates;
			this.equivalentUSD = (rates["USD"] * this.expenseRenderAmount).toFixed(2);
		},
		wantsToUpdateEquivalentUSD() {
			this.isEquivalentUSDEditing = true;
			setTimeout(() => {
				document.querySelector(".equivalentUSDInput").focus();
			}, 500);
		}
	}
};
</script>
